import { sbEditable } from '@storyblok/storyblok-editable';
import classNames from 'classnames';
import type { ReactElement, RefObject } from 'react';
import { useRef } from 'react';
import type { TitleTextColumnsProps } from './TitleTextColumns.data';
import styles from './TitleTextColumns.module.scss';
import {
  setupTransitionInTimeline,
  setupTransitionOutTimeline,
} from './TitleTextColumns.transitions';
import { useChangeTransitionState } from 'util/react-transition-component/hooks/useChangeTransitionState';
import { useTransitionController } from 'util/react-transition-component';
import Heading from '../../atoms/heading/Heading';
import { NODE_PARAGRAPH, render } from 'storyblok-rich-text-react-renderer';
import Text from '../../atoms/text/Text';

export default function TitleTextColumns({
  isVisible,
  className,
  blok,
  ref,
}: TitleTextColumnsProps): ReactElement {
  const localRef = useRef(null);
  const elementRef = (ref || localRef) as RefObject<HTMLDivElement | null>;

  const transitionController = useTransitionController(
    () => ({
      ref: elementRef,
      refs: {
        elementRef,
      },
      setupTransitionInTimeline,
      setupTransitionOutTimeline,
    }),
    [],
  );

  useChangeTransitionState(transitionController, isVisible);

  return (
    <div
      ref={elementRef}
      className={classNames(styles.titleTextColumns, className)}
      {...sbEditable(blok)}
    >
      <Heading
        as="h3"
        size="heading-03"
        disableTriggerInOnScroll={false}
        transitionInType="splitCharsSlideInUp"
        className={styles.title}
      >
        {blok.title}
      </Heading>

      <div className={styles.textContainer}>
        {render(blok.text, {
          nodeResolvers: {
            [NODE_PARAGRAPH]: (children) => (
              <Text
                className={styles.paragraph}
                as="p"
                size="body-large"
                transitionInType="splitCharsWordsRichText"
                disableTriggerInOnScroll={false}
                // canTransitionIn={canTransitionIn}
              >
                {children}
              </Text>
            ),
          },
        })}
      </div>
    </div>
  );
}
